import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Spinner, Table, Alert } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { apiListUsers } from "../../helpers/backend_api";

const UsersPage = () => {
  document.title = "Users | ApprentAI";
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    apiListUsers({ limit: 50, offset: 0 })
      .then((res) => {
        if (cancelled) return;
        const payload = res?.data || res;
        setUsers(payload?.user_list || []);
        setTotal(payload?.total_user || 0);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err?.message || "Failed to load users");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="USERS" pageTitle="Dashboards" />

        <button className="my-3 btn btn-primary"> Add User </button>
        <div className="text-muted small mb-2">Total users: {total}</div>

        {error ? <Alert color="danger">{String(error)}</Alert> : null}

        <Row>
          <Col>
            <Card>
              <CardBody>
                {loading ? (
                  <div className="text-center py-4">
                    <Spinner /> Loading users…
                  </div>
                ) : (
                  <Table className="table-bordered table-responsive align-middle table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Office</th>
                        <th>Groups</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.length === 0 ? (
                        <tr>
                          <td colSpan={7} className="text-center text-muted">
                            No users found.
                          </td>
                        </tr>
                      ) : (
                        users.map((u) => (
                          <tr key={u.id}>
                            <td className="fw-medium">{u.id}</td>
                            <td>
                              {u.name}
                              {u.last_name ? ` ${u.last_name}` : ""}
                            </td>
                            <td>{u.email}</td>
                            <td>{u.role_data?.role_name || "—"}</td>
                            <td>{u.office || "—"}</td>
                            <td>{u.user_group_string_format || "—"}</td>
                            <td>
                              <i className="mdi mdi-pencil-outline me-3 fs-22"></i>
                              <i className="mdi mdi-trash-can-outline fs-22"></i>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UsersPage;
